// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.price .title {
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 0 !important;
}
.price .title h1 {
  font-size: 40px;
  font-weight: 600;
  position: relative;
  z-index: 1111;
}
.price .title p {
  color: var(--ion-color-medium);
  font-size: 16px;
  margin-top: 10px;
  position: relative;
  z-index: 1111;
}
.price .title p span {
  color: var(--ion-color-medium);
}
.price ion-list {
  height: 100%;
  padding-top: 16px;
  padding: 32px;
  border-bottom: 1px solid var(--ion-color-light);
}
.price ion-list ion-item {
  margin-bottom: 10px;
}
.price ion-list ion-label {
  font-size: 16px !important;
}
.price ion-list ion-note {
  font-size: 16px !important;
}

.data {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.data .title {
  height: 100%;
}
.data .title h1 {
  font-size: 45px;
}
.data .title p {
  font-size: 25px !important;
  margin-bottom: 16px;
}
.data .title p span {
  font-size: 25px !important;
}

.radio-container {
  margin: 0px -8px;
}

@media (max-width: 767px) {
  .data {
    padding-bottom: env(safe-area-inset-bottom) !important;
  }
  .price {
    padding: 32px;
  }
}
.title h1 {
  font-size: 50px;
}
.title h2 {
  font-size: 25px;
  font-weight: 400;
}
.title h2 span {
  font-size: 25px;
}
.title h3 {
  font-size: 20px;
  font-weight: 600;
}

ion-footer ion-button {
  font-size: 19px !important;
  height: 60px !important;
  --border-radius: 8px;
}
ion-footer .radio-container {
  margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/payments/credit-board/credit-board.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AACN;AAEI;EACE,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AAAN;AAEM;EACE,8BAAA;AAAR;AAKE;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,+CAAA;AAHJ;AAKI;EACE,mBAAA;AAHN;AAMI;EACE,0BAAA;AAJN;AAOI;EACE,0BAAA;AALN;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAPF;AASE;EACE,YAAA;AAPJ;AASI;EACE,eAAA;AAPN;AAUI;EACE,0BAAA;EACA,mBAAA;AARN;AAUM;EACE,0BAAA;AARR;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE;IACE,sDAAA;EAXF;EAcA;IACE,aAAA;EAZF;AACF;AAgBE;EACE,eAAA;AAdJ;AAiBE;EACE,eAAA;EACA,gBAAA;AAfJ;AAiBI;EACE,eAAA;AAfN;AAmBE;EACE,eAAA;EACA,gBAAA;AAjBJ;;AAsBE;EACE,0BAAA;EACA,uBAAA;EACA,oBAAA;AAnBJ;AAsBE;EACE,oBAAA;AApBJ","sourcesContent":[".price {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .title {\n    text-align: center;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-bottom: 0 !important;\n\n    h1 {\n      font-size: 40px;\n      font-weight: 600;\n      position: relative;\n      z-index: 1111;\n    }\n\n    p {\n      color: var(--ion-color-medium);\n      font-size: 16px;\n      margin-top: 10px;\n      position: relative;\n      z-index: 1111;\n\n      span {\n        color: var(--ion-color-medium);\n      }\n    }\n  }\n\n  ion-list {\n    height: 100%;\n    padding-top: 16px;\n    padding: 32px;\n    border-bottom: 1px solid var(--ion-color-light);\n\n    ion-item {\n      margin-bottom: 10px;\n    }\n\n    ion-label {\n      font-size: 16px !important;\n    }\n\n    ion-note {\n      font-size: 16px !important;\n    }\n  }\n}\n\n.data {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n\n  .title {\n    height: 100%;\n\n    h1 {\n      font-size: 45px;\n    }\n\n    p {\n      font-size: 25px !important;\n      margin-bottom: 16px;\n\n      span {\n        font-size: 25px !important;\n      }\n    }\n  }\n}\n\n.radio-container {\n  margin: 0px -8px;\n}\n\n@media (max-width: 767px) {\n  .data {\n    padding-bottom: env(safe-area-inset-bottom) !important;\n  }\n\n  .price {\n    padding: 32px;\n  }\n}\n\n.title {\n  h1 {\n    font-size: 50px;\n  }\n\n  h2 {\n    font-size: 25px;\n    font-weight: 400;\n\n    span {\n      font-size: 25px;\n    }\n  }\n\n  h3 {\n    font-size: 20px;\n    font-weight: 600;\n  }\n}\n\nion-footer {\n  ion-button {\n    font-size: 19px !important;\n    height: 60px !important;\n    --border-radius: 8px;\n  }\n\n  .radio-container {\n    margin: 0 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
